import React from 'react';
import { useKeyPressEvent } from 'react-use';
import { Heading1, Regular } from '@oxygen/typography';

import ClientOnlyPortal from '../client-only-portal';
import { ExplanationBackground, ExplanationWrapper, CloseIcon } from './styles';

const CloseMatchExplanation = ({ onClose }) => {
  const predicate = (event) => event.keyCode === 27;
  useKeyPressEvent(predicate, () => {
    onClose();
  });

  return (
    <ClientOnlyPortal selector='#modal'>
      <ExplanationBackground
        onClick={(e) => {
          e.preventDefault();
          onClose();
        }}
      />
      <ExplanationWrapper
        onClick={(e) => {
          // this is to prevent bubbling up the component tree
          e.preventDefault();
        }}
      >
        <CloseIcon
          onClick={(e) => {
            e.preventDefault();
            onClose();
          }}
        />
        <Heading1>What’s a close match?</Heading1>
        <Regular>
          <strong>A close match</strong> is a property that matches your search
          filters with 75-99% accuracy. The search results are sorted by most to
          least accurate.
        </Regular>
        <Regular>
          We will always show you 100% matches first, if there are any.
        </Regular>
        <Regular>
          <em>
            It’s a little like dating. You hope your date will have those dreamy
            eyes and that colgate smile, but they may also like cats instead of
            dogs, but you still fall for them...
          </em>
        </Regular>
      </ExplanationWrapper>
    </ClientOnlyPortal>
  );
};

export default CloseMatchExplanation;
